// Share.CredlyBadging.Sso/Share.CredlySSO.Button.SSOButton
import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

export type CPCredlySSOLocNames =
	| 'CPCredlySSOPageTitle'
	| 'CPCredlySSOPageDescription'
	| 'CPCredlySSOButton';

export const cpCredlySSOLocs: LocDefs<CPCredlySSOLocNames> = {
	CPCredlySSOPageTitle: {
		legacyName: 'Share.CredlyBadging.Sso/Share.CredlySSO.PageTitle',
		defaultValue: 'Credly SSO',
		description: 'The title of the Credly SSO page',
		displayPath: 'Share|SSO|Credly|Page Title',
		displayType: 'Title',
		feature: HubFeature.ShareCredlyBadgingSso,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCredlySSOPageDescription: {
		legacyName: 'Share.CredlyBadging.Sso/Share.CredlySSO.PageDescription',
		defaultValue: '',
		description: 'The description of the Credly SSO page',
		displayPath: 'Share|SSO|Credly|Page Description',
		displayType: 'Content',
		feature: HubFeature.ShareCredlyBadgingSso,
		htmlAllowed: true,
		shared: false,
		portal: 'CP',
	},
	CPCredlySSOButton: {
		legacyName: 'Share.CredlyBadging.Sso/Share.CredlySSO.Button.SSOButton',
		defaultValue: 'SSO to Credly',
		description: 'The button to SSO to Credly',
		displayPath: 'Share|SSO|Credly|SSO Button',
		displayType: 'Button',
		feature: HubFeature.ShareCredlyBadgingSso,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
};

export const cpCredlySSOLocNames = MapLocKeys<CPCredlySSOLocNames>(cpCredlySSOLocs);
export type CPCredlySSOLocKeys = typeof cpCredlySSOLocNames;
